'use strict';

var angular = require('angular');
function DjangoFormController($http, $q, $log) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.submit = submit;
  vm.isHiddenField = isHiddenField;

  vm._uppercaseMethod = _uppercaseMethod;
  vm._transformData = _transformData;
  vm._isMethod = _isMethod;

  vm._requestSuccess = _requestSuccess;
  vm._requestFailed = _requestFailed;
  vm._resetForm = _resetForm;
  vm._resetFields = _resetFields;

  vm._setValidity = _setValidity;
  vm._request = _request;

  function $onInit() {
    vm.formStructure = {};
    vm.formData = {};
    vm.formClass = vm.formClass || 'form-horizontal';
    vm.fieldClass = vm.fieldClass || 'col-xs-10';
    vm.labelClass = vm.labelClass || 'col-xs-2';
    vm.buttonSpinner = vm.buttonSpinner || {};
    vm.onSubmit = vm.onSubmit || '';
    vm.method = vm.method || 'POST';
    vm.url = vm.url || '';
    vm.hiddenFields = vm.hiddenFields || [];

    if (angular.isDefined(vm.url)) {
      var promise = [ $http(_request('OPTIONS')) ];

      if (!_isMethod('post')) {
        promise.push($http.get(vm.url));
      }

      return $q.all(promise).then(function(response) {
        vm.formStructure = response[0].data;

        if (!_isMethod('post')) {
          vm.formData = _transformData(response[1].data);
        }

        return response;
      });
    }
  }

  function submit() {
    var req = _request(vm.method);

    if (_isMethod('post') || _isMethod('put')) {
      req.data = vm.formData;
    }

    var promise = $http(req);
    promise
      .then(_requestSuccess)
      .catch(_requestFailed)
      .finally(_resetForm);

    if (angular.isFunction(vm.onSubmit)) {
      vm.onSubmit(promise);
    }
  }

  function isHiddenField(field) {
    return vm.hiddenFields.indexOf(field) !== -1;
  }

  function _uppercaseMethod(method) {
    return (method || '').toUpperCase();
  }

  function _transformData(data) {
    Object.keys(data).forEach(function(key) {
      if (angular.isArray(data[key])) {
        data[key] = data[key].map(function (value) {return (value.id || value.toString()) + '';});
      }
    });

    return data;
  }

  function _isMethod(method) {
    return _uppercaseMethod(vm.method) === _uppercaseMethod(method);
  }

  function _requestSuccess(response) {
    vm.formData = _isMethod('put') ? _transformData(response.data) : {};
    _resetFields(response.data, true);
    return response;
  }

  function _requestFailed(response) {
    $log.info(response);
    _resetFields(response.data, false);
    return response;
  }

  function _resetForm() {
    vm.form.$setPristine(true);
    vm.form.$setUntouched(false);
  }

  function _resetFields(data, validity) {
    Object.keys(data).forEach(vm._setValidity(validity));
    vm._resetForm();
  }

  function _setValidity(bool) {
    return function (k) {
      if (vm.form && vm.form.hasOwnProperty(k)) {
        vm.form[k].$setValidity(k, bool);
      }
    };
  }

  function _request(method) {
    return { url: vm.url, method: method };
  }
}

module.exports = DjangoFormController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/django-form/django-form.controller.js
 ** module id = 47
 ** module chunks = 0
 **/